import React from 'react';
import { formatCreatedAt } from '@/utils/format';
export function DisplayCreatedAt({
  createdAt,
  format = 'YYYY-MM-DD HH:mm:ss',
  isUnix = false
}) {
  if (createdAt === 0) {
    return /*#__PURE__*/React.createElement("div", null, "-");
  }

  if (isUnix) {
    return /*#__PURE__*/React.createElement("div", null, formatCreatedAt(createdAt, true, format));
  }

  return /*#__PURE__*/React.createElement("div", null, formatCreatedAt(createdAt / 1000000000, false, format));
}